import { render } from "./NcrmMailjetWebhooksTab.vue?vue&type=template&id=44692508&scoped=true"
import script from "./NcrmMailjetWebhooksTab.vue?vue&type=script&lang=js"
export * from "./NcrmMailjetWebhooksTab.vue?vue&type=script&lang=js"

import "./NcrmMailjetWebhooksTab.vue?vue&type=style&index=0&id=44692508&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-44692508"]])

export default __exports__